import angular from "angular";
import angularUIB from "angular-ui-bootstrap";
import angularFilters from "angular-filter";
import core from "../core/core.module";
import role from "./role";
import roleForm from "./role-form/role-form";
import moduleForm from "./module-form/module-form";
import permissionForm from "./permission-form/permission-form";

angular
    .module('accessControlCrud.component', [
        angularUIB,
        angularFilters,
        role,
        core,
        roleForm,
        moduleForm,
        permissionForm
    ])
    .component('accessControlCrud', {
        controller: ['$uibModal', 'Role', 'notifier', controller],
        template: require('./access-control-crud.component.html'),
        bindings: {
            roles: '<',
            modules: '<',
        }
    });

function controller($uibModal, Role, notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function (){
        $ctrl.type = 'owner';
        $ctrl.selectedRole = null;
    };

    $ctrl.filterModules = function (module) {
        return (module.type == 'all' || $ctrl.type == module.type);
    };

    $ctrl.selectType = function (type) {
        $ctrl.type = type;
        $ctrl.selectedRole = null;
        updatePermissionsStatus();
    };

    $ctrl.selectRole = function (role) {
        if ($ctrl.selectedRole == role) {
            $ctrl.selectedRole = null;
        } else {
            $ctrl.selectedRole = role;
        }
        updatePermissionsStatus();
    };

    function updatePermissionsStatus() {

        $ctrl.modules.forEach(function (module) {
            module.permissions.forEach(function (permission) {
                permission.isSelected = false;
            });
        });

        if ($ctrl.selectedRole) {
            $ctrl.selectedRole.permissions.forEach(function (rolePermission) {
                for (let i = 0; i < $ctrl.modules.length; i++) {
                    if ($ctrl.modules[i].id == rolePermission['module_id']) {
                        for (let j = 0; j < $ctrl.modules[i].permissions.length; j++) {
                            if ($ctrl.modules[i].permissions[j].id == rolePermission['id']) {
                                $ctrl.modules[i].permissions[j].isSelected = true;
                                break;
                            }
                        }
                        break;
                    }
                }
            });
        }

    }

    $ctrl.togglePermission = function (permission) {
        if (permission.loading) {
            return;
        }
        permission.loading = true;
        Role
            .togglePermission($ctrl.selectedRole.id, permission.id)
            .then(
                function () {
                    permission.loading = false;
                    if (permission.isSelected) {
                        for (let i = 0; i < $ctrl.selectedRole.permissions.length; i++) {
                            if ($ctrl.selectedRole.permissions[i].id == permission.id) {
                                $ctrl.selectedRole.permissions.splice(i, 1);
                                break;
                            }
                        }
                    } else {
                        $ctrl.selectedRole.permissions.push(window.angular.copy(permission));
                    }
                    permission.isSelected = !permission.isSelected;
                },
                function (error) {
                    permission.loading = false;
                    notifier.errorResponseNotify(error);
                }
            );
    };

    $ctrl.openRoleForm = function (role) {
        $uibModal
            .open({
                component: 'roleForm',
                resolve: {
                    type: function () {
                        return $ctrl.type;
                    },
                    role: function () {
                        return role
                    }
                }
            })
            .result
            .then(
                function (result) {
                    if (role) {
                        if (result.role) {
                            role.key = result.role.key;
                            role.name = result.role.name;
                            role.description = result.role.description;
                        } else {
                            for (let i = 0; i < $ctrl.roles.length; i++) {
                                if ($ctrl.roles[i].id == role.id) {
                                    $ctrl.roles.splice(i, 1);
                                    break;
                                }
                            }
                            $ctrl.selectedRole = null;
                            updatePermissionsStatus();
                        }
                    } else {
                        role = result.role;
                        role.permissions = [];
                        $ctrl.roles.push(role);
                    }
                }
            );
    };

    $ctrl.openModuleForm = function (module) {
        $uibModal
            .open({
                component: 'moduleForm',
                resolve: {
                    module: function () {
                        return module
                    }
                }
            })
            .result
            .then(
                function (result) {
                    if (module) {
                        if (result.module) {
                            module.key = result.module.key;
                            module.name = result.module.name;
                            module.description = result.module.description;
                        } else {
                            for (let i = 0; i < $ctrl.modules.length; i++) {
                                if ($ctrl.modules[i].id == module.id) {
                                    $ctrl.modules.splice(i, 1);
                                    break;
                                }
                            }
                        }
                    } else {
                        module = result.module;
                        module.permissions = [];
                        $ctrl.modules.push(module);
                    }
                }
            );
    };

    $ctrl.openPermissionForm = function (module, permission) {
        $uibModal
            .open({
                component: 'permissionForm',
                resolve: {
                    moduleId: function () {
                        return module.id;
                    },
                    permission: function () {
                        return permission;
                    }
                }
            })
            .result
            .then(
                function (result) {
                    if (permission) {
                        if (result.permission) {
                            permission.key = result.permission.key;
                            permission.name = result.permission.name;
                        } else {
                            for (let i = 0; i < module.permissions.length; i++) {
                                if (module.permissions[i].id == permission.id) {
                                    module.permissions.splice(i, 1);
                                    break;
                                }
                            }
                        }
                    } else {
                        module.permissions.push(result.permission);
                    }
                }
            );
    };

}

export default "accessControlCrud.component";


// WEBPACK FOOTER //
// ./resources/assets/modules/access-control-crud/access-control-crud.component.js